<script lang="ts" setup>
import type {NuxtError} from '#app'
import seoRedirects from '../data/seo-redirects.json';

const {error} = defineProps<{ error: NuxtError }>();
const {t} = useI18n();
// Check for SEO redirects
if (import.meta.client) {
    const currentUrl = window.location.href;
    // Check for exact or partial match in redirect keys
    for (const [oldUrl, newUrl] of Object.entries(seoRedirects as Record<string, string>)) {
        console.log(oldUrl, newUrl, currentUrl);
        if (currentUrl.includes(oldUrl) || currentUrl === oldUrl) {
            // Redirect with 301 (permanent redirect)
            window.location.replace(newUrl);
            break;
        }
    }
}
</script>

<template>
  <div>
    <NuxtRouteAnnouncer/>
    <NuxtLayout>
      <main class="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8 min-h-[60vh]">
        <p class="text-base/8 font-semibold text-dark">{{ error.statusCode }}</p>
        <h1
                v-if="error.statusCode === 404"
                class="mt-4 text-5xl font-semibold tracking-tight text-balance text-dark sm:text-7xl">
          {{ t('404.title') }}
        </h1>
        <div v-if="error.statusCode === 404" class="mt-6 text-lg font-medium text-pretty text-dark/70 sm:text-xl/8">
          <p>{{ error?.statusMessage }}</p>
          <p>{{ t('404.description') }}</p>
        </div>
        <div class="mt-10 flex justify-center">
          <a class="text-sm/7 font-semibold text-dark hover:text-dark/90" href="/"><span
                  aria-hidden="true">&larr;</span> {{ t('404.home_link') }}
          </a>
        </div>
      </main>
    </NuxtLayout>
  </div>
</template>